export default __webpack_public_path__ + "static/media/11.9f70d326.jpg";